// extracted by css-extract-rspack-plugin
export default {"base":"StartProcedureCard__base--ZFnqA","title":"StartProcedureCard__title--WXtK2","button":"StartProcedureCard__button--iQRbY"};